/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var KEY_PREFIX = exports.KEY_PREFIX = 'reduxPersist:';
var REHYDRATE = exports.REHYDRATE = 'persist/REHYDRATE';



//////////////////
// WEBPACK FOOTER
// ./node_modules/mattermost-redux/node_modules/redux-persist/lib/constants.js
// module id = 968
// module chunks = 76